import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f64fe2be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f64fe2be&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=f64fe2be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64fe2be",
  null
  
)

export default component.exports